/* Cookie consent — designed, not wired.

   The production platform wires this to Consent Mode v2; here it persists the
   choice to localStorage so the banner behaves realistically. Every read and
   write is guarded: a private window or blocked site data must not throw. */
(function () {
  'use strict';
  var KEY = 'aw-consent';
  var root = document.querySelector('[data-aw-consent]');
  if (!root) return;

  function read() {
    try { return localStorage.getItem(KEY); } catch (e) { return null; }
  }
  function write(value) {
    try {
      localStorage.setItem(KEY, JSON.stringify(value));
    } catch (e) { /* storage blocked — the choice simply is not remembered */ }
  }

  if (read() !== null) return;
  root.hidden = false;

  var panel = root.querySelector('[data-aw-consent-panel]');
  var title = root.querySelector('[data-aw-consent-title]');
  var text = root.querySelector('[data-aw-consent-text]');
  var list = root.querySelector('[data-aw-consent-list]');
  var collapse = root.querySelector('[data-aw-consent-collapse]');
  var btnAccept = root.querySelector('[data-aw-consent-accept]');
  var btnReject = root.querySelector('[data-aw-consent-reject]');
  var btnSave = root.querySelector('[data-aw-consent-save]');
  var btnOpen = root.querySelector('[data-aw-consent-open]');
  var settings = false;

  if (panel) panel.focus();

  function render() {
    title.textContent = settings ? 'Kies zelf wat je toestaat' : 'Wij gebruiken cookies';
    text.hidden = settings;
    list.hidden = !settings;
    collapse.hidden = !settings;
    btnReject.hidden = settings;
    btnSave.hidden = !settings;
    btnOpen.hidden = settings;
    panel.classList.toggle('consent__panel--wide', settings);
  }

  function save(value) {
    value.ts = new Date().toISOString();
    write(value);
    root.hidden = true;
  }

  btnAccept.addEventListener('click', function () {
    save({ noodzakelijk: true, voorkeuren: true, statistieken: true, marketing: true });
  });
  btnReject.addEventListener('click', function () {
    save({ noodzakelijk: true, voorkeuren: false, statistieken: false, marketing: false });
  });
  btnSave.addEventListener('click', function () {
    var out = { noodzakelijk: true };
    Array.prototype.forEach.call(list.querySelectorAll('input[type="checkbox"]'), function (i) {
      out[i.name] = i.checked;
    });
    save(out);
  });
  btnOpen.addEventListener('click', function () { settings = true; render(); });
  collapse.addEventListener('click', function () { settings = false; render(); });

  /* Escape collapses the settings view rather than dismissing the banner:
     silently closing would record no choice, which is not consent. */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && settings) { settings = false; render(); }
  });

  render();
})();
